/**
 * Скрипт автоматического расчёта высоты textarea.
 * Активирует автоматический расчёт высоты textarea через плагин autosize.
 *
 * @module Autosize
 *
 * @see {@link https://github.com/jackmoore/autosize}
 */

import autosize from 'autosize';

autosize($('textarea'));
$('textarea').css('resize', '');
